import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService, CommonService, ToasterService } from '../../services';
import { IResponseMessage } from '../../models';

import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { Constants } from '../../common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonFunctions } from '../../classes';

@Component({
  selector: 'app-email-verification-popup',
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule
  ],
  templateUrl: './email-verification-popup.component.html',
  styleUrl: './email-verification-popup.component.scss'
})
export class EmailVerificationPopupComponent {

  isMailSending = false;
  isMailSent = false;
  isVerificationInProgress = false;
  isVerified = false;

  emailVerificationForm!: FormGroup;

  constructor(private authService: AuthService, private fb: FormBuilder, private toaster: ToasterService, private dialogRef: MatDialogRef<EmailVerificationPopupComponent>, private commonService: CommonService) {
    this.initializeForms();
  }

  initializeForms() {
    this.emailVerificationForm = this.fb.group({
      verification_code: ['', Validators.required]
    });
  }

  verifyEmail() {
    this.isMailSending = true;
    this.authService.emailVerification().subscribe({
      next: (data: IResponseMessage) => {
        this.isMailSending = false;
        this.isMailSent = true;
        // console.log(data);
      },
      error: (error: HttpErrorResponse) => {
        this.toaster.error(error?.error?.message ? error?.error?.message : Constants.notifyMessages.commonErrorLoading);
        this.isMailSending = false;
        this.isMailSent = false;
      }
    }
    )
  }

  verifyCode() {
    if (this.emailVerificationForm.valid) {
      this.isVerificationInProgress = true;
      this.authService.emailVerificationCheck(this.emailVerificationForm.value).subscribe({
        next: (data: IResponseMessage) => {
          this.isVerificationInProgress = false;
          this.isVerified = true;
          // console.log(data);
          this.toaster.success(data?.message ? data?.message : Constants.notifyMessages.emailVerified);
          this.dialogRef.close('close');
        },
        error: (error: HttpErrorResponse) => {
          this.toaster.error(error?.error?.message ? error?.error?.message : Constants.notifyMessages.commonErrorLoading);
          console.log(error);
          this.isVerificationInProgress = false;
          this.isVerified = false;
        }
      }
      )
    }
    else {
      Object.values(this.emailVerificationForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }
  }

  logout() {
    this.dialogRef.close('logout');
    this.authService.logout();
  }

  closeDialogue() {
    this.dialogRef.close('close');
  }

  isLogoutButtonVisible() {
    const diffDays = CommonFunctions.getDaysSinceBusinessCreated(this.commonService?.profileDetail?.business_created_at);
    if (diffDays > Constants.minimumDaysForEmailVerification) {
      return true;
    }
    else {
      return false;
    }
  }

}
